import { useLocalStorage } from '@mantine/hooks';
import {
  useEnabledFeatures,
  useMe,
  useOwnerPortalPreviewSession,
  useTeam,
} from '@vrplatform/data';
import { useCallback } from 'react';

export function useChatVRTVisibility() {
  const [{ isGL: GL }] = useTeam();
  const { CHAT_VRT } = useEnabledFeatures();
  const { id: userId } = useMe();
  // A preview tab still holds the manager's Clerk session, which ChatVRT uses.
  const isOwnerPortalPreview = !!useOwnerPortalPreviewSession();
  const [disabled, setDisabled] = useLocalStorage<boolean>({
    key: `chatvrt.disabled.${userId}`,
    defaultValue: false,
    getInitialValueInEffect: false,
  });
  const toggleDisabled = useCallback(() => {
    setDisabled((current) => !current);
  }, [setDisabled]);
  const available = GL && CHAT_VRT && !isOwnerPortalPreview;

  return {
    active: available && !disabled,
    available,
    disabled,
    toggleDisabled,
  };
}
